<template>
  <div class="layout">
    <Header v-show="!pda.status" class="layout-header" @menu-state="menuState" />
    <header-pda v-show="pda.status" />
    <div class="layout-body">
      <!-- <Menu v-if="!pda.status" ref="menu" class="layout-menu" /> -->
      <div class="layout-page">
        <message-notice ref="MsgNotice" class="mb20" />
        <router-view v-if="Object.keys(btnauth).length > 0" :class="{'page': !pda.status, 'page-pda':pda.status}" :key="$route.path"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/common/Header.vue'
import HeaderPda from '@/components/common/HeaderPda.vue'
// import Menu from '@/components/common/Menu.vue'
import MessageNotice from '@/components/common/MessageNotice.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'layout',
  components: {
    Header,
    HeaderPda,
    // Menu,
    MessageNotice
  },
  data() {
    return {
      notification: {
        instance: null,
        handle: {},
        close: () => {
          if (this.notification.instance) {
            this.notification.instance.close()
            this.notification.instance = null
          }
        }
      }
    }
  },
  watch: {
    '$route.path': {
      handler() {
        this.freshNotice()
        this.notification.close()
      }
    }
  },
  created() {
    this.startGetSystemTime()
    this.watchVisibilityChange()
    this.getSocket()
  },
  computed: {
    ...mapGetters(['btnauth', 'pda', 'exec', 'user'])
  },
  methods: {
    freshNotice() {
      if (this.$refs.MsgNotice) {
        this.$refs.MsgNotice.refresh()
      } else {
        setTimeout(() => {
          this.freshNotice()
        }, 100)
      }
    },
    async getSocket() {
      const socket = await this.$socket()
      const { path } = this.$route
      socket.on('alert_recycle_rollback', (message) => {
        const data = JSON.parse(message)
        const { msg, affect_all, affect_routes } = data
        if (!affect_all && !affect_routes.includes(path)) return

        this.$confirm(msg, '提示', {
          confirmButtonText: '前往查看',
          cancelButtonText: '稍后再说',
          type: 'warning'
        }).then(() => {
          this.$router.push(`/inquire/instrument_problem/index`)
        })
      })

      socket.on('notice', (message) => {
        this.handleNoticeMsg(message)
      })
    },
    async handleClickNotification() {
      const { handle } = this.notification
      const { url_type, url, tab } = handle
      if (url_type == 1) {
        const { path } = this.$route
        this.$router.push(`${url}?tab=${tab}`)

        if (path.startsWith(url)) {
          const confirm = await this.$utils.confirm({ msg: '您已经在待处理的页面上，是否需要重新加载？'})

          if (confirm) {
            window.location.reload()
          }
        }
      } else if (url_type == 3) {
        window.open(url, '_blank')
      }

      this.notification.close()
    },
    handleNoticeMsg(message) {
      // 处理业务通知消息
      try {
        const data = JSON.parse(message)
        const { url_data, affect_range, msg } = data
        const { affect_all, affect_routes, except_department_id } = affect_range
        const { department_data } = this.user
        if (except_department_id && except_department_id.includes(department_data.id)) return

        const { path } = this.$route
        if (affect_all || affect_routes.filter(i => path.startsWith(i))[0]) {
          this.notification.handle = url_data || {}
          this.openNoticeMessage(msg)
        }
      } catch (error) {
        console.log('消息解析出错', error)
      }
    },

    openNoticeMessage(msg) {
      this.notification.close()

      const btnStyle = {
        'width': '180px',
        'height': '40px',
        'line-height': '40px',
        'border': '1px solid #00afde',
        'border-radius': '4px',
        'text-align': 'center',
        'cursor': 'pointer',
        'color': '#00afde',
        'margin-top': '10px'
      }
      const styleString = Object.keys(btnStyle).map(i => `${i}:${btnStyle[i]}`).join(';')
      this.notification.instance = this.notification.instance || this.$notify({
        title: msg,
        type: 'info',
        position: 'bottom-right',
        dangerouslyUseHTMLString: true,
        duration: 0,
        customClass: 'notice-message',
        onClick: this.handleClickNotification,
        message: `<div style="${styleString}">去处理</div>`
      });
    },
    watchVisibilityChange() {
      // 监听浏览器tab切换
      document.addEventListener('visibilitychange', () => {
        const state = document.visibilityState
        if (state === 'visible') {
          this.startGetSystemTime()
        }
      })
    },
    menuState(state) {
      this.$refs.menu.setState(state)
    },
    startGetSystemTime() {
      this.$utils.getTime()
    },
  }
}
</script>

<style lang="scss" scoped>
  .layout {
    height: 100%;
    padding: 60px 0 0;
    position: relative;
    .layout-header {
      min-width: inherit;
    }
    .layout-body {
      display: flex;
      height: calc(100vh - 60px);
      background: #eef0f9;
      overflow: hidden;
      .layout-menu {
        max-width: 220px;
      }
      .layout-page {
        padding: 15px 10px;
        flex: 1;
        overflow-x: auto;
        .page {
          min-width: 1080px;
        }
        .page-pda {
          width: 100%;
          min-height: 100%;
        }
      }
    }
  }
</style>
<style lang="scss">
  @import '@/assets/css/common.scss';
  .notice-message {
    .el-notification__closeBtn {
      color: $main_color_deep;
      font-size: 20px;
    }
  }
</style>